import { getOrganisationsCurrentSavingsOpportunitiesSelector } from "./getOrganisationsCurrentSavingsOpportunitiesSelector";
import { RootState } from "../../store";

export const savingsOpportunitiesLoadingSelector = (
  state: RootState,
  resourceId?: string,
) => {
  return getOrganisationsCurrentSavingsOpportunitiesSelector(resourceId)(state)
    ?.isLoading;
};
